import { useEffect } from 'react'

/**
 * Keep `document.title` in step with a translated (or otherwise dynamic)
 * title. The caller passes the rendered string — translation happens where
 * `useTranslation` already lives, and the hook stays a one-line primitive.
 *
 * Leaving hands the previous title back, so the next page never shows this one's.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
